import { useTranslation } from 'react-i18next';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { MyStatement } from 'src/Components/FundCalls/MyStatement';

const MyStatementPage = () => {
  const { t } = useTranslation();

  return (
    <AnimatedRoutedDrawer title={t('fundCalls.myStatement.title', 'Mon relevé')}>
      {() => <MyStatement />}
    </AnimatedRoutedDrawer>
  );
};

export default MyStatementPage;
